import {
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@material-ui/core";
import { useContext } from "react";
import { BoletoContext } from "./contexts/BoletoContext";
import useBilletController from "./controllers/BoletoController";
import { LoginContainer, LoginForm } from "./styles/Login";

const View = () => {
  const {
    empresaCnpj,
    setEmpresaCnpj,
    password,
    setPassword,
    email,
    setEmail,
    isButtonLoading,
  } = useContext(BoletoContext);

  const { signIn } = useBilletController();

  return (
    <LoginContainer>
      <LoginForm>
        <Typography variant="h2" color="primary">
          Acesse para visualizar seus <strong>contratos</strong>
        </Typography>
        <TextField
          label="CNPJ"
          value={empresaCnpj}
          onChange={(event) => setEmpresaCnpj(event.target.value)}
        />
        <TextField
          label="E-mail"
          value={email}
          type={"email"}
          onChange={(event) => setEmail(event.target.value)}
        />
        <TextField
          label="Senha"
          value={password}
          type="password"
          onChange={(event) => setPassword(event.target.value)}
        />
        <Button
          disabled={isButtonLoading}
          color={"primary"}
          variant="contained"
          onClick={async () => await signIn()}
        >
          {isButtonLoading ? <CircularProgress /> : "Entrar"}
        </Button>
      </LoginForm>
    </LoginContainer>
  );
};

const BoletoLogin = () => <View />;

export default BoletoLogin;
